import { ThemeUICSSObject } from 'theme-ui';
import { spacing } from '../../../../util';

export const bpmGraphViewer: ThemeUICSSObject = {
  '&.bpmGraphViewer': {
    boxSizing: 'border-box',
    position: 'relative',
    width: '100%',
    maxWidth: '100%',
    minWidth: 0,
    overflow: 'hidden',
    color: 'palette.text.primary',

    '.bpmGraphViewer__thumbnailWrap': {
      position: 'relative',
      margin: '0 auto',
      maxWidth: 'calc(100% - 20px)',
      width: 'calc(100% - 20px)',
    },

    '.bpmGraphViewer__thumbnail': {
      position: 'relative',
      boxSizing: 'border-box',
      alignItems: 'center',
      color: 'inherit',
      cursor: 'pointer',
      background: 'transparent',
      border: 'none',
      display: 'flex',
      height: '320px',
      justifyContent: 'center',
      margin: 0,
      maxWidth: '100%',
      minHeight: 0,
      overflow: 'hidden',
      padding: spacing(4),
      width: '100%',
    },

    '.bpmGraphViewer__thumbnail:focus-visible': {
      outline: '2px solid',
      outlineColor: 'palette.primary.main',
      outlineOffset: '2px',
    },

    '.bpmGraphViewer__thumbnailSvg': {
      boxSizing: 'border-box',
      display: 'block',
      height: '100%',
      maxHeight: '100%',
      maxWidth: '100%',
      minHeight: 0,
      minWidth: 0,
      overflow: 'hidden',
      pointerEvents: 'none',
      width: '100%',

      svg: {
        display: 'block',
        height: '100%',
        maxHeight: '100%',
        maxWidth: '100%',
        minHeight: 0,
        minWidth: 0,
        overflow: 'visible',
        width: '100%',
      },
    },

    '.bpmGraphViewer__thumbnail img': {
      maxHeight: '100%',
      maxWidth: '100%',
      objectFit: 'contain',
    },

    '.bpmGraphViewer__thumbnailAction': {
      position: 'absolute',
      right: spacing(3),
      bottom: spacing(3),
      alignItems: 'center',
      background: 'palette.background.paper',
      border: '1px solid',
      borderColor: 'palette.border.field',
      borderRadius: 'default',
      boxShadow: 'default',
      color: 'palette.text.primary',
      display: 'inline-flex',
    },

    '.bpmGraphViewer__controlButton.iconButton': {
      borderRadius: 'panel',
      flexShrink: 0,
      height: '34px',
      minHeight: '34px',
      minWidth: '34px',
      width: '34px',
    },

    '.bpmGraphViewer__toolbar .bpmGraphViewer__controlButton.iconButton, .bpmGraphViewer__thumbnailAction .bpmGraphViewer__controlButton.iconButton, .formPreview__gridFooter .bpmGraphViewer__controlButton.iconButton, .formPreview__fileInfoButton.bpmGraphViewer__controlButton.iconButton':
      {
        background: 'transparent',
        border: 'none',
        color: 'palette.text.primary',
      },

    '.bpmGraphViewer__thumbnailWrap:hover .bpmGraphViewer__thumbnailAction, .bpmGraphViewer__thumbnailWrap:focus-within .bpmGraphViewer__thumbnailAction':
      {
        color: 'palette.primary.main',
      },

    '&.bpmGraphViewer--modalRoot': {
      overflow: 'visible',
    },

    '.bpmGraphViewer__modal': {
      position: 'fixed',
      inset: 0,
      zIndex: 2000,
      alignItems: 'stretch',
      background: 'rgba(15, 23, 42, 0.72)',
      display: 'flex',
      justifyContent: 'stretch',
    },

    '.bpmGraphViewer__modal--inline': {
      position: 'absolute',
      background: 'palette.background.paper',
      zIndex: 3,
    },

    '.bpmGraphViewer__modalContent': {
      position: 'relative',
      background: 'palette.background.paper',
      flex: '1 1 auto',
      height: '100%',
      overflow: 'hidden',
      width: '100%',
    },

    '.bpmGraphViewer__modalClose': {
      position: 'absolute',
      top: spacing(4),
      right: spacing(4),
      zIndex: 4,
      background: 'rgba(255, 255, 255, 0.92)',
      boxShadow: 'default',
    },

    '.bpmGraphViewer__viewport': {
      '--bpm-task-preview-width': 'clamp(300px, 34vw, 430px)',
      position: 'relative',
      boxSizing: 'border-box',
      alignItems: 'center',
      background: 'palette.background.paper',
      cursor: 'grab',
      display: 'flex',
      height: '100%',
      justifyContent: 'center',
      minHeight: 0,
      overflow: 'hidden',
      padding: spacing(4),
      touchAction: 'none',
      userSelect: 'none',
      width: '100%',
    },

    '.bpmGraphViewer__viewport--panning': {
      cursor: 'grabbing',
    },

    '.bpmGraphViewer__imageContent': {
      position: 'relative',
      display: 'block',
      flex: '0 0 auto',
      willChange: 'width, height, left, top',
    },

    '.bpmGraphViewer__imageContent--animating': {
      transition:
        'width 300ms ease, height 300ms ease, left 300ms ease, top 300ms ease',
    },

    '.bpmGraphViewer__imageContent img, .bpmGraphViewer__viewport img': {
      objectFit: 'contain',
    },

    '.bpmGraphViewer__inlineSvg': {
      cursor: 'grab',

      svg: {
        display: 'block',
        height: '100%',
        maxHeight: '100%',
        maxWidth: '100%',
        minHeight: 0,
        minWidth: 0,
        overflow: 'visible',
        width: '100%',
      },
    },

    '.bpmGraphViewer__inlineSvg rect.bpa-map-task, .bpmGraphViewer__inlineSvg g.bpa-map-task > rect, .bpmGraphViewer__inlineSvg .bpa-map-task, .bpmGraphViewer__inlineSvg .bpa-map-edge-line, .bpmGraphViewer__inlineSvg .bpa-map-gateway polygon, .bpmGraphViewer__inlineSvg g.bpa-map-gateway > polygon, .bpmGraphViewer__inlineSvg .bpa-map-event circle':
      {
        transition:
          'fill 160ms ease, opacity 160ms ease, stroke 160ms ease, stroke-width 160ms ease',
      },

    '.bpmGraphViewer__inlineSvg .bpa-map-task, .bpmGraphViewer__inlineSvg .bpa-map-gateway, .bpmGraphViewer__inlineSvg .bpa-map-event, .bpmGraphViewer__inlineSvg .bpa-map-edge':
      {
        cursor: 'pointer',
      },

    '.bpmGraphViewer__inlineSvg .bpa-map-text, .bpmGraphViewer__inlineSvg line:not(.bpa-map-edge-line):not(.bpa-map-edge-hit), .bpmGraphViewer__inlineSvg .bpa-map-gateway ellipse':
      {
        pointerEvents: 'none',
      },

    '.bpmGraphViewer__inlineSvg .bpa-map-edge-line': {
      pointerEvents: 'stroke',
    },

    '.bpmGraphViewer__inlineSvg .bpa-map-edge-hit': {
      fill: 'none',
      pointerEvents: 'stroke',
      stroke: 'transparent',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeWidth: 14,
    },

    '.bpmGraphViewer__inlineSvg .bpa-map-edge-label, .bpmGraphViewer__inlineSvg .bpa-map-edge-label-group, .bpmGraphViewer__inlineSvg .bpa-map-edge-label-bg, .bpmGraphViewer__inlineSvg .bpa-map-edge-label-group text':
      {
        cursor: 'pointer',
        pointerEvents: 'all',
      },

    '.bpmGraphViewer__inlineSvg .bpa-map-edge-label, .bpmGraphViewer__inlineSvg .bpa-map-edge-label-group text':
      {
        fill: '#444',
      },

    '.bpmGraphViewer__inlineSvg .bpa-map-edge-label-bg': {
      fill: 'none',
      stroke: 'none',
    },

    '.bpmGraphViewer__inlineSvg rect.bpa-map-task.bpa-map-hover, .bpmGraphViewer__inlineSvg g.bpa-map-task.bpa-map-hover > rect, .bpmGraphViewer__inlineSvg polygon.bpa-map-gateway.bpa-map-hover, .bpmGraphViewer__inlineSvg g.bpa-map-gateway.bpa-map-hover > polygon, .bpmGraphViewer__inlineSvg g.bpa-map-event.bpa-map-hover > circle':
      {
        stroke: '#0d6efd',
        strokeWidth: 5,
      },

    '.bpmGraphViewer__inlineSvg rect.bpa-map-task.bpa-map-selected, .bpmGraphViewer__inlineSvg g.bpa-map-task.bpa-map-selected > rect':
      {
        fill: 'rgba(13, 110, 253, 0.12)',
        filter: 'drop-shadow(0 0 4px rgba(13, 110, 253, 0.32))',
        stroke: '#0d6efd',
        strokeWidth: 6,
      },

    '.bpmGraphViewer__inlineSvg .bpa-map-edge.bpa-map-hover .bpa-map-edge-line, .bpmGraphViewer__inlineSvg .bpa-map-edge.bpa-map-hover--outgoing .bpa-map-edge-line':
      {
        stroke: '#0d6efd',
        strokeWidth: 4,
      },

    '.bpmGraphViewer__inlineSvg .bpa-map-edge.bpa-map-hover .bpa-map-edge-label, .bpmGraphViewer__inlineSvg .bpa-map-edge.bpa-map-hover .bpa-map-edge-label-group text, .bpmGraphViewer__inlineSvg .bpa-map-edge-label.bpa-map-hover, .bpmGraphViewer__inlineSvg .bpa-map-edge-label-group.bpa-map-hover text, .bpmGraphViewer__inlineSvg .bpa-map-edge.bpa-map-hover--outgoing .bpa-map-edge-label, .bpmGraphViewer__inlineSvg .bpa-map-edge.bpa-map-hover--outgoing .bpa-map-edge-label-group text, .bpmGraphViewer__inlineSvg .bpa-map-edge-label.bpa-map-hover--outgoing, .bpmGraphViewer__inlineSvg .bpa-map-edge-label-group.bpa-map-hover--outgoing text':
      {
        fill: '#0d6efd',
        fontWeight: 700,
      },

    '.bpmGraphViewer__inlineSvg .bpa-map-edge.bpa-map-hover--incoming .bpa-map-edge-line':
      {
        stroke: '#198754',
        strokeWidth: 4,
      },

    '.bpmGraphViewer__inlineSvg .bpa-map-edge.bpa-map-hover--incoming .bpa-map-edge-label, .bpmGraphViewer__inlineSvg .bpa-map-edge.bpa-map-hover--incoming .bpa-map-edge-label-group text, .bpmGraphViewer__inlineSvg .bpa-map-edge-label.bpa-map-hover--incoming, .bpmGraphViewer__inlineSvg .bpa-map-edge-label-group.bpa-map-hover--incoming text':
      {
        fill: '#198754',
        fontWeight: 700,
      },

    '.bpmGraphViewer__inlineSvg rect.bpa-map-task.bpa-map-hover--outgoing, .bpmGraphViewer__inlineSvg g.bpa-map-task.bpa-map-hover--outgoing > rect':
      {
        stroke: '#0d6efd',
        strokeWidth: 5,
      },

    '.bpmGraphViewer__inlineSvg rect.bpa-map-task.bpa-map-hover--recursive.bpa-map-hover--outgoing, .bpmGraphViewer__inlineSvg g.bpa-map-task.bpa-map-hover--recursive.bpa-map-hover--outgoing > rect':
      {
        fill: 'rgba(13, 110, 253, 0.15)',
      },

    '.bpmGraphViewer__inlineSvg rect.bpa-map-task.bpa-map-hover--incoming, .bpmGraphViewer__inlineSvg g.bpa-map-task.bpa-map-hover--incoming > rect':
      {
        stroke: '#198754',
        strokeWidth: 5,
      },

    '.bpmGraphViewer__inlineSvg rect.bpa-map-task.bpa-map-hover--recursive.bpa-map-hover--incoming, .bpmGraphViewer__inlineSvg g.bpa-map-task.bpa-map-hover--recursive.bpa-map-hover--incoming > rect':
      {
        fill: 'rgba(25, 135, 84, 0.15)',
      },

    '.bpmGraphViewer__toolbar': {
      position: 'absolute',
      right: spacing(3),
      bottom: spacing(3),
      zIndex: 2,
      alignItems: 'center',
      background: 'rgba(255, 255, 255, 0.92)',
      border: '1px solid',
      borderColor: 'palette.border.field',
      borderRadius: 'default',
      boxShadow: 'default',
      display: 'flex',
      gap: spacing(1),
      padding: spacing(1),
    },

    '.bpmGraphViewer__taskPreviewOverlay': {
      position: 'absolute',
      top: spacing(4),
      bottom: spacing(4),
      left: spacing(4),
      zIndex: 3,
      width: 'var(--bpm-task-preview-width)',
      maxWidth: 'calc(100% - 32px)',
      overflowY: 'auto',
      padding: spacing(1),
      pointerEvents: 'auto',
      scrollbarWidth: 'none',
    },

    '.bpmGraphViewer__taskPreviewOverlay::-webkit-scrollbar': {
      display: 'none',
    },

    '.bpmGraphViewer__taskPreviewStack': {
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(4),
    },

    '.bpmGraphViewer__taskPreviewStack .processPreview__detailsCard': {
      background: 'palette.background.paper',
      border: '1px solid',
      borderColor: 'palette.border.field',
      borderRadius: 'default',
      boxShadow: 'default',
      minWidth: 0,
      overflow: 'hidden',
    },

    '.bpmGraphViewer__taskPreviewStack .processPreview__header': {
      alignItems: 'center',
      background: 'palette.background.paper',
      borderBottom: '1px solid',
      borderColor: 'palette.border.field',
      display: 'flex',
      minHeight: '34px',
      padding: `${spacing(2)} ${spacing(3)}`,
    },

    '.bpmGraphViewer__taskPreviewStack .processPreview__title': {
      color: 'palette.text.primary',
      fontWeight: 700,
      minWidth: 0,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },

    '.bpmGraphViewer__taskPreviewStack .processPreview__detailsList': {
      borderCollapse: 'collapse',
      margin: 0,
      tableLayout: 'fixed',
      width: '100%',

      'tbody tr:first-of-type .processPreview__detailsLabel, tbody tr:first-of-type .processPreview__detailsValue':
        {
          borderTop: 0,
        },
    },

    '.bpmGraphViewer__taskPreviewStack .processPreview__detailsLabel': {
      borderTop: '1px solid',
      borderColor: 'palette.border.field',
      color: 'palette.text.disabled',
      fontWeight: 600,
      minWidth: 0,
      padding: spacing(3),
      textAlign: 'left',
      verticalAlign: 'top',
      width: '160px',
    },

    '.bpmGraphViewer__taskPreviewStack .processPreview__detailsValue': {
      borderTop: '1px solid',
      borderColor: 'palette.border.field',
      color: 'palette.text.primary',
      minWidth: 0,
      overflowWrap: 'anywhere',
      padding: spacing(3),
      verticalAlign: 'top',
    },

    '.bpmGraphViewer__taskPreviewStack .processPreview__valueList': {
      display: 'flex',
      flexWrap: 'wrap',
      columnGap: spacing(1),
      minWidth: 0,
      rowGap: spacing(1),
    },

    '.bpmGraphViewer__taskPreviewStack .processPreview__valueItem': {
      color: 'palette.text.primary',
      maxWidth: '100%',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },

    '.bpmGraphViewer__taskPreviewStack .processPreview__valueSeparator': {
      color: 'palette.text.disabled',
    },

    '.bpmGraphViewer__taskPreviewStack .processPreview__taskFloatingPanel': {
      background: 'palette.background.paper',
      border: '1px solid',
      borderColor: 'palette.border.field',
      borderRadius: 'default',
      boxShadow: 'default',
      boxSizing: 'border-box',
      minWidth: 0,
      padding: spacing(3),
      width: '100%',
      zIndex: 2,
    },

    '.bpmGraphViewer__taskPreviewStack .processPreview__taskFloatingTitle': {
      color: 'palette.text.primary',
      fontWeight: 700,
      lineHeight: 1.35,
      minWidth: 0,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },

    '.bpmGraphViewer__taskPreviewStack .processPreview__taskFloatingPerformer':
      {
        color: 'palette.text.disabled',
        fontSize: '0.92em',
        lineHeight: 1.35,
        marginTop: spacing(1),
        minWidth: 0,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      },

    '.bpmGraphViewer__taskPreviewStack .processPreview__contextFormsToggle': {
      alignItems: 'center',
      color: 'palette.text.secondary',
      cursor: 'pointer',
      display: 'flex',
      fontSize: '0.92em',
      gap: spacing(2),
      lineHeight: 1.35,
      marginTop: spacing(2),
      userSelect: 'none',
    },

    '.bpmGraphViewer__taskPreviewStack .processPreview__contextFormsToggleInput':
      {
        flex: '0 0 auto',
        margin: 0,
      },

    '.bpmGraphViewer__taskPreviewStack .processPreview__empty': {
      color: 'palette.text.disabled',
      padding: spacing(3),
    },

    '.bpmGraphViewer__taskPreviewStack .processPreview__taskForms': {
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(4),
      minWidth: 0,
    },

    '.bpmGraphViewer__taskPreviewStack .processPreview__taskFormSlot--context':
      {
        display: 'none',
      },

    '.bpmGraphViewer__taskPreviewStack .processPreview__taskForms:has(.processPreview__contextFormsToggleInput:checked) .processPreview__taskFormSlot--context':
      {
        display: 'block',
      },

    '.bpmGraphViewer__taskPreviewEmpty': {
      background: 'rgba(255, 255, 255, 0.86)',
      border: '1px solid',
      borderColor: 'palette.border.field',
      borderRadius: 'default',
      boxShadow: 'default',
      color: 'palette.text.secondary',
      padding: spacing(4),
    },

    '.bpmGraphViewer__legend': {
      position: 'absolute',
      left: spacing(4),
      bottom: spacing(4),
      zIndex: 2,
      alignItems: 'center',
      background: 'rgba(255, 255, 255, 0.92)',
      border: '1px solid',
      borderColor: 'palette.border.field',
      borderRadius: 'default',
      boxShadow: 'default',
      display: 'none',
      gap: spacing(3),
      padding: `${spacing(2)} ${spacing(3)}`,
      pointerEvents: 'none',
    },

    '.bpmGraphViewer__viewport--hasOutgoingHover .bpmGraphViewer__legend, .bpmGraphViewer__viewport--hasIncomingHover .bpmGraphViewer__legend':
      {
        display: 'flex',
      },

    '.bpmGraphViewer__legendItem': {
      alignItems: 'center',
      display: 'inline-flex',
      gap: spacing(2),
      whiteSpace: 'nowrap',
    },

    '.bpmGraphViewer__legendSwatch': {
      borderRadius: '50%',
      display: 'inline-block',
      height: '10px',
      width: '10px',
    },

    '.bpmGraphViewer__legendItem--outgoing .bpmGraphViewer__legendSwatch': {
      background: '#0d6efd',
    },

    '.bpmGraphViewer__legendItem--incoming .bpmGraphViewer__legendSwatch': {
      background: '#198754',
    },

    '.bpmGraphFormPreview': {
      boxSizing: 'border-box',
      background: 'palette.background.default',
      color: 'palette.text.primary',
      height: '100%',
      minHeight: 0,
      minWidth: 0,
      overflow: 'visible',
      width: '100%',
    },

    '.bpmGraphFormPreview--embedded': {
      background: 'transparent',
      height: 'auto',
      padding: 0,
    },

    '.bpmGraphFormPreview--embedded .formPreview__form': {
      gridTemplateColumns: 'minmax(0, 1fr) !important',
    },

    '.bpmGraphFormPreview--embedded .formPreview__field, .bpmGraphFormPreview--embedded .formPreview__grid':
      {
        gridColumn: '1 / -1 !important',
      },

    '.bpmGraphViewer__taskPreviewOverlay .bpmGraphFormPreview': {
      background: 'rgba(255, 255, 255, 0.86)',
      borderRadius: 'default',
      boxShadow: 'default',
      backdropFilter: 'blur(5px)',
    },

    '.bpmGraphFormPreview .formPreview__accordion': {
      containerType: 'inline-size',
      margin: '0 auto',
      maxWidth: '920px',
      minWidth: 0,
      width: '100%',
    },

    '.bpmGraphFormPreview--embedded .formPreview__accordion': {
      maxWidth: 'none',
    },

    '.bpmGraphFormPreview .accordion__item': {
      background: 'palette.background.paper',
      border: 'none',
      borderRadius: 'default',
      boxShadow: 'default',
      minWidth: 0,
      overflow: 'hidden',
    },

    '.bpmGraphFormPreview .accordion__item__button[class]': {
      borderRadius: '4px 4px 0 0',
      padding: `${spacing(3)} ${spacing(4)}`,
      userSelect: 'none',
      width: '100%',
    },

    '.bpmGraphFormPreview .accordion__item__button[class] .button__content': {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'space-between',
      minWidth: 0,
      width: '100%',
    },

    '.bpmGraphFormPreview .accordion__item__button__label': {
      fontWeight: 700,
      minWidth: 0,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },

    '.bpmGraphFormPreview .accordion__item__button__rightGroup': {
      alignItems: 'center',
      display: 'inline-flex',
      flex: '0 0 auto',
      gap: spacing(2),
      minWidth: 0,
    },

    '.bpmGraphFormPreview .accordion__item__content': {
      background: 'palette.background.paper',
      border: '1px solid',
      borderColor: 'palette.border.field',
      borderTop: 0,
      borderRadius: '0 0 4px 4px',
      minWidth: 0,
      overflow: 'hidden',
    },

    '.bpmGraphFormPreview .accordion__item__content > .formPreview__form': {
      boxShadow: 'none',
      padding: spacing(4),
    },

    '.bpmGraphFormPreview .formPreview__form': {
      alignContent: 'start',
      background: 'palette.background.paper',
      boxSizing: 'border-box',
      gap: spacing(4),
      minWidth: 0,
      width: '100%',
    },

    '.bpmGraphFormPreview .formPreview__field': {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'stretch',
      minHeight: '64px',
      minWidth: 0,
    },

    '.bpmGraphFormPreview .formPreview__field.field__area, .bpmGraphFormPreview .formPreview__field.field__file':
      {
        minHeight: 0,
      },

    '.bpmGraphFormPreview .formPreview__field.field__check, .bpmGraphFormPreview .formPreview__field.field__radio, .bpmGraphFormPreview .formPreview__field.field__button':
      {
        minHeight: '44px',
      },

    '.bpmGraphFormPreview .field__label[class]': {
      alignItems: 'stretch',
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(2),
      height: '100%',
      margin: 0,
      minWidth: 0,
      width: '100%',
    },

    '.bpmGraphFormPreview .field__title_container': {
      alignItems: 'center',
      display: 'flex',
      minHeight: '20px',
      minWidth: 0,
    },

    '.bpmGraphFormPreview .field__title': {
      alignItems: 'center',
      display: 'inline-flex',
      fontWeight: 700,
      gap: spacing(1),
      maxWidth: '100%',
      minWidth: 0,
      overflow: 'hidden',
    },

    '.bpmGraphFormPreview .formPreview__fieldTitleText': {
      minWidth: 0,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },

    '.bpmGraphFormPreview .required.formPreview__requiredIndicator': {
      color: 'palette.error.main',
      flex: '0 0 auto',
      textDecoration: 'none',
    },

    '.bpmGraphFormPreview .field__control_container': {
      alignItems: 'center',
      display: 'flex',
      flex: '1 1 auto',
      minHeight: 0,
      minWidth: 0,
      width: '100%',
    },

    '.bpmGraphFormPreview .formPreview__inputHost': {
      display: 'flex',
      minWidth: 0,
      width: '100%',
    },

    '.bpmGraphFormPreview .formPreview__inputHost input, .bpmGraphFormPreview .formPreview__inputHost select, .bpmGraphFormPreview .formPreview__inputHost textarea':
      {
        boxSizing: 'border-box',
        font: 'inherit',
        maxWidth: '100%',
        minHeight: '34px',
        minWidth: 0,
        width: '100%',
      },

    '.bpmGraphFormPreview .formPreview__inputHost textarea': {
      minHeight: '96px',
      resize: 'vertical',
    },

    '.bpmGraphFormPreview .formPreview__field--readonly .formPreview__inputHost input, .bpmGraphFormPreview .formPreview__field--readonly .formPreview__inputHost select, .bpmGraphFormPreview .formPreview__field--readonly .formPreview__inputHost textarea':
      {
        backgroundColor: 'palette.background.default',
        color: 'palette.text.secondary',
        cursor: 'default',
      },

    '.bpmGraphFormPreview .formPreview__field.field__check .fake__label, .bpmGraphFormPreview .formPreview__field.field__button .fake__label':
      {
        display: 'none',
      },

    '.bpmGraphFormPreview .formPreview__field.field__check .label': {
      alignItems: 'center',
      display: 'flex',
      gap: spacing(2),
      margin: 0,
      minWidth: 0,
      width: '100%',
    },

    '.bpmGraphFormPreview .formPreview__field.field__radio .fieldset, .bpmGraphFormPreview .formPreview__field.field__radio .radio__layout__wrapper':
      {
        minWidth: 0,
        width: '100%',
      },

    '.bpmGraphFormPreview .formPreview__field.field__radio .radio_label': {
      display: 'flex',
      fontWeight: 700,
      marginBottom: spacing(2),
      minWidth: 0,
    },

    '.bpmGraphFormPreview .formPreview__field.field__radio .option__container':
      {
        display: 'flex',
        flexWrap: 'wrap',
        gap: `${spacing(2)} ${spacing(4)}`,
        minWidth: 0,
      },

    '.bpmGraphFormPreview .formPreview__field.field__radio .radio': {
      alignItems: 'center',
      display: 'inline-flex',
      gap: spacing(2),
      margin: 0,
      minWidth: 0,
    },

    '.bpmGraphFormPreview .formPreview__optionLabel': {
      color: 'palette.text.primary',
      minWidth: 0,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },

    '.bpmGraphFormPreview .formPreview__buttonHost': {
      alignItems: 'center',
      display: 'flex',
      minWidth: 0,
      width: '100%',
    },

    '.bpmGraphFormPreview .formPreview__grid': {
      background: 'palette.background.paper',
      border: '1px solid',
      borderColor: 'palette.border.field',
      borderRadius: 'default',
      display: 'flex',
      flexDirection: 'column',
      minHeight: 0,
      minWidth: 0,
      overflow: 'hidden',
    },

    '.bpmGraphFormPreview .formPreview__gridTitle': {
      borderBottom: '1px solid',
      borderBottomColor: 'palette.border.field',
      fontWeight: 700,
      minWidth: 0,
      overflow: 'hidden',
      padding: `${spacing(2)} ${spacing(3)}`,
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },

    '.bpmGraphFormPreview .formPreview__gridTableScroller': {
      minHeight: 0,
      minWidth: 0,
      overflow: 'auto',
    },

    '.bpmGraphFormPreview .formPreview__gridTable': {
      borderCollapse: 'collapse',
      width: '100%',
    },

    '.bpmGraphFormPreview .formPreview__gridTable th, .bpmGraphFormPreview .formPreview__gridTable td':
      {
        minWidth: '150px',
        verticalAlign: 'top',
      },

    '.bpmGraphFormPreview .formPreview__gridCellControl': {
      minWidth: 0,
    },

    '.bpmGraphFormPreview .formPreview__gridFooter': {
      alignItems: 'center',
      borderTop: '1px solid',
      borderTopColor: 'palette.border.field',
      display: 'flex',
      justifyContent: 'space-between',
      padding: spacing(2),
    },

    '.bpmGraphFormPreview .formPreview__gridFooterStart, .bpmGraphFormPreview .formPreview__gridFooterActions':
      {
        alignItems: 'center',
        display: 'inline-flex',
        gap: spacing(2),
      },

    '.bpmGraphFormPreview .formPreview__fileDropzone.dropzone__container': {
      alignItems: 'center',
      background: 'palette.background.paper',
      border: '1px solid',
      borderColor: 'palette.border.field',
      display: 'flex',
      height: '40px',
      minWidth: 0,
      overflow: 'hidden',
      padding: 0,
      width: '100%',
    },

    '.bpmGraphFormPreview .formPreview__fileDropzoneTarget': {
      alignItems: 'center',
      alignSelf: 'stretch',
      backgroundImage:
        'repeating-linear-gradient(45deg, #f1f1f1 0, #f1f1f1 4px, #fff 4px, #fff 16px)',
      border: 'none',
      color: 'palette.text.primary',
      cursor: 'default',
      display: 'flex',
      flex: '1 1 auto',
      font: 'inherit',
      justifyContent: 'center',
      margin: '4px 0 4px 4px',
      minWidth: 0,
      overflow: 'hidden',
      padding: `0 ${spacing(4)}`,
      textAlign: 'center',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },

    '.bpmGraphFormPreview .formPreview__fileDropzoneTarget:focus': {
      outline: '2px solid rgba(80, 80, 80, 0.22)',
      outlineOffset: '-2px',
    },

    '.bpmGraphFormPreview .formPreview__fileDropzone--readonly .formPreview__fileDropzoneTarget':
      {
        backgroundColor: 'palette.background.default',
        backgroundImage: 'none',
        color: 'palette.text.secondary',
        cursor: 'default',
      },

    '.bpmGraphFormPreview .formPreview__fileInfoButton.iconButton': {
      alignItems: 'center',
      alignSelf: 'center',
      background: 'transparent',
      border: 'none',
      boxShadow: 'none',
      color: 'palette.text.secondary',
      cursor: 'default',
      display: 'inline-flex',
      flex: '0 0 40px',
      justifyContent: 'center',
      margin: 0,
    },

    '.bpmGraphFormPreview .formPreview__gridCellControl .formPreview__fileDropzone.dropzone__container':
      {
        height: '42px',
      },

    '.bpmGraphFormPreview .formPreview__gridCellControl .formPreview__fileDropzoneTarget':
      {
        margin: '3px 0 3px 3px',
        padding: `0 ${spacing(2)}`,
      },

    '.bpmGraphFormPreview .formPreview__gridCellControl .formPreview__fileInfoButton.iconButton':
      {
        flexBasis: '40px',
      },

    '.bpmGraphFormPreview .formPreview__empty': {
      color: 'palette.text.secondary',
      padding: spacing(4),
    },

    '.bpmGraphViewer__gridModal': {
      position: 'fixed',
      inset: 0,
      zIndex: 2100,
      alignItems: 'center',
      background: 'rgba(15, 23, 42, 0.64)',
      display: 'flex',
      justifyContent: 'center',
      padding: spacing(5),
    },

    '.bpmGraphViewer__gridModalContent': {
      background: 'palette.background.paper',
      boxShadow: 'default',
      maxHeight: '90vh',
      maxWidth: '95vw',
      width: 'min(1100px, 95vw)',
    },
  },
};
